module.exports = __webpack_public_path__ + "static/media/49.49e80bfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/49.jpg
// module id = 610
// module chunks = 0